import type {
  AchievementLevel,
  GroupConceptChipDetail,
  StudentChipAchievement,
} from '@mathflat/domain/Achievement'
import { groupBy } from 'lodash-es'

/** 그룹 유형칩 상세 — 학생별 성취도와 정답률 상·하위 문제 */
export class GroupAchievementConceptChipDetail {
  averageCorrectRate: GroupConceptChipDetail['averageCorrectRate']
  highestCorrectRateProblems: GroupConceptChipDetail['highestCorrectRateProblems']
  highestWrongRateProblems: GroupConceptChipDetail['highestWrongRateProblems']
  averageAchievementLevel: GroupConceptChipDetail['averageAchievementLevel']
  achievements: GroupConceptChipDetail['achievements']

  constructor(data: GroupConceptChipDetail) {
    this.averageCorrectRate = data.averageCorrectRate
    this.highestCorrectRateProblems = data.highestCorrectRateProblems
    this.highestWrongRateProblems = data.highestWrongRateProblems
    this.averageAchievementLevel = data.averageAchievementLevel
    this.achievements = data.achievements
  }

  get achievementsGroupedByLevel() {
    return groupBy(this.achievements, 'achievementLevel') as Record<
      AchievementLevel,
      StudentChipAchievement[]
    >
  }
}
